import { Calendar } from "@algomusinc/domain";
import { groupBy } from "lodash";
import moment from "moment";
// import { TreeviewItem } from "ngx-treeview";
import { environment } from 'apps/algo/src/environments/environment';
export const CreateCalendarList = (
  calendarListDropdown: any,
  timeframeList: any,
  forecast: any
) => {
  calendarListDropdown = [];
  return [];
};
export const CreateTimeframeList = (
  calendarListDropdown: any,
  timeframeList: any,
  selectable: boolean,
  expanded: boolean = false
) => {
  calendarListDropdown = [];
  const uniqueYears: any[] = [
    ...new Set(timeframeList.map((item: Calendar) => item.fy)),
  ]; // ['FY18']
  uniqueYears.forEach((year: string, index): any => {
    const yearList = timeframeList.filter((row: any) => row.fy === year);
    const uniqueHalfYears: any[] = [
      ...new Set(yearList.map((item: Calendar) => item.hy)),
    ]; // ['H1']
    const uniqueQuarters: any[] = [];
    const uniquemonths: any[] = [];
    yearList.forEach((y: any) => {
      if (
        uniqueQuarters.findIndex(
          (x) => x.quarter === y.quarter && x.hy === y.hy
        ) < 0
      ) {
        uniqueQuarters.push({ quarter: y.quarter, hy: y.hy });
      }
      if (
        uniquemonths.findIndex(
          (x) => x.quarter === y.quarter && x.month === y.month
        ) < 0
      ) {
        uniquemonths.push({ quarter: y.quarter, month: y.month });
      }
    });
    // const uniqueQuarters = yearList.filter(year => year.quarter)
    const obj = {
      label: year,
      data: year,
      icon: '',
      leaf: false,
      expanded: expanded,
      type: '',
      partialSelected: false,
      styleClass: '',
      draggable: false,
      droppable: false,
      selectable: selectable,
      key: year,
      isRoot: true,
      children: uniqueHalfYears.map(
        (h: string) =>
          ({
            label: h,
            data: h,
            icon: '',
            leaf: false,
            expanded: expanded,
            type: '',
            partialSelected: false,
            styleClass: '',
            draggable: false,
            droppable: false,
            selectable: selectable,
            key: h,
            children: uniqueQuarters
              .filter((e) => e.hy === h)
              .map(
                (q) => ({
                    label: q.quarter,
                    data: q.quarter,
                    icon: '',
                    leaf: false,
                    expanded: expanded,
                    type: '',
                    partialSelected: false,
                    styleClass: '',
                    draggable: false,
                    droppable: false,
                    selectable: selectable,
                    key: q.quarter,
                    children: uniquemonths
                      .filter((el) => el.quarter === q.quarter)
                      .map((m) => ({
                        label: m.month,
                        data: yearList
                        .filter(
                          (el: any) =>
                            el.month === m.month &&
                            el.quarter === q.quarter &&
                            el.hy === h
                        )
                        .map((cal: any) => cal.calendarId),
                        icon: '',
                        leaf: true,
                        expanded: expanded,
                        type: '',
                        partialSelected: false,
                        styleClass: '',
                        draggable: false,
                        droppable: false,
                        key: m.month,
                        selectable: selectable,
                        children: []
                      })),
                  })
              ),
          })
      ),
    };
    calendarListDropdown.push(obj);
  });
  return calendarListDropdown;
}
  export const manipulateCalenderHierarchy = (calenderList: Array<any>, selectable: boolean, expanded: boolean, nodeClass?: string, showLeaf?:boolean) => {
    const isLevelHide = false;
    calenderList = calenderList.map((row) => {
      return {
        ...row,
        ParentId: row.ParentId ? row.ParentId : null,
      };
    });
    const grouped = groupBy(
      calenderList,
      (calender) => calender.ParentId
    );


    function childrenOf(parentId: any): any {
      return (grouped[parentId] || []).map((calender) => {
        return {
          parentId: calender.ParentId ? calender.ParentId : null,
          label: calender.Name === 'Leaf' ? moment.utc(calender.Description).format(environment.DATE_FORMAT)  : calender.Description,
          data: calender.Id,
          key: calender.ParentId ? `${calender.ParentId}${calender.Id}`: `${calender.Id}`,
          icon: '',
          isRoot: calender.Position == 1 ? true : false,
          leaf: calender.Name === 'Leaf' ? true: false,
          expanded: expanded,
          partialSelected: false,
          styleClass: nodeClass,
          draggable: true,
          droppable: false,
          selectable: selectable,
          level: calender.Position,
          children: childrenOf(calender.Id),
          metaData: calender,
          name: calender.Name,
          calenderId: calender.Id
        }
      })
    }
    function removeLeaf(treeList:any){
      if(treeList["children"] && treeList["children"][0].name == 'Leaf'){
        treeList.leaf = true
        treeList.data = [];
        treeList["children"].forEach((child:any)=>{
          delete treeList["children"][0]
          treeList.data.push(child.data);
          treeList["children"] = treeList["children"].filter((e:any)=>e);
        });
      }
      treeList["children"].forEach((child:any)=>removeLeaf(child));
      return treeList;
    }

    let calenderTree = childrenOf(null);
    let dataArray = {
      children: calenderTree
    }
    if(!showLeaf){
      dataArray = removeLeaf(dataArray);
    }
    calenderTree = dataArray["children"];
    return calenderTree;
  }


